import { createReducer } from 'Helpers/redux'
import {
  GET_IS_RECIPIENT_CHECKING_NEEDED,
  GET_CURRENCIES,
  GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS,
  SPECIFY_TRANSFERWISE_ACCOUNT_REQUIREMENTS,
  SET_REQUIREMENTS_TO_INITIAL_STATE,
  GET_COUNTRIES,
  GET_RECIPIENT_BANK_DETAILS,
  ADD_TRANSFERWISE_RECIPIENT,
} from '../actions/transferwiseActions'

const initialState = {
  isRecipientCheckingNeeded: false,
  currencies: [],
  requirements: [],
  countries: [],
  recipient: null,
}

const handlers = {
  [GET_IS_RECIPIENT_CHECKING_NEEDED.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    isRecipientCheckingNeeded: payload,
  }),
  [GET_CURRENCIES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    currencies: payload.data,
  }),
  [GET_COUNTRIES.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    countries: payload.data,
  }),
  [GET_RECIPIENT_BANK_DETAILS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    recipient: payload,
  }),
  [ADD_TRANSFERWISE_RECIPIENT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    recipient: payload,
  }),
  [GET_TRANSFERWISE_ACCOUNT_REQUIREMENTS.SUCCESS]: (
    prevState,
    { payload }
  ) => ({
    ...prevState,
    requirements: payload.data,
  }),
  [SPECIFY_TRANSFERWISE_ACCOUNT_REQUIREMENTS.SUCCESS]: (
    prevState,
    { payload }
  ) => ({
    ...prevState,
    requirements: payload.data,
  }),
  [SET_REQUIREMENTS_TO_INITIAL_STATE]: (prevState, { payload }) => ({
    ...prevState,
    requirements: payload,
  }),
}

export default createReducer(initialState, handlers)
